import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { referenceTypes } from '@app/hcs-shared';
import { ComponentSync, EditableDBItemV3, Grid, SimpleListAdapter, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { exists } from '@nu-art/ts-common';
import { ModuleFE_Reference } from '../../../_entity.js';
import './Editor_Reference.scss';
import { FadeScrollWrapper } from '@app/styles';
import { Editor_Reference_Article } from './ref-editors/Editor_Reference_Article.js';
import { Editor_Reference_UpToDate } from './ref-editors/Editor_Reference_UpToDate.js';
import { Editor_Reference_Book } from './ref-editors/Editor_Reference_Book.js';
export class Editor_Reference extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editMode = nextProps.editMode;
        if (typeof nextProps.reference === 'string') {
            if (nextProps.reference !== state.editable?.item._id)
                state.editable = this.getEditable(nextProps.reference);
        }
        else
            state.editable = nextProps.reference;
        state.lockRefTypes = nextProps.lockRefTypes;
        return state;
    }
    shouldComponentUpdate(nextProps, nextState, nextContent) {
        //Force re-render if the editable reference comes from the parent component
        return typeof nextProps.reference !== 'string' ? true : super.shouldComponentUpdate(nextProps, nextState, nextContent);
    }
    // ######################## Logic ########################
    getEditable(referenceId) {
        const reference = ModuleFE_Reference.cache.unique(referenceId) ?? {};
        return new EditableDBItemV3(reference, ModuleFE_Reference)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(() => this.forceUpdate())
            .setAutoSave(true);
    }
    // ######################## Render ########################
    render() {
        return _jsx(FadeScrollWrapper, { className: 'e__reference', children: _jsxs(Grid, { children: [this.render_Type(), this.render_Data()] }) });
    }
    render_Type = () => {
        const items = this.state.lockRefTypes?.length ? referenceTypes.filter(type => this.state.lockRefTypes.includes(type)) : [...referenceTypes];
        const adapter = SimpleListAdapter(items, i => _jsx(_Fragment, { children: i.item }));
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Type', children: _jsx(TS_DropDown, { adapter: adapter, disabled: exists(this.state.editable.item._id), selected: this.state.editable.item.type, queryFilter: t => t !== this.state.editable.item.type, onSelected: type => {
                    this.state.editable.updateObj({
                        type,
                        data: {},
                    });
                } }) });
    };
    render_Data = () => {
        const editable = this.state.editable;
        const editableData = editable.editProp('data', {});
        switch (editable.item.type) {
            case 'article':
                return _jsx(Editor_Reference_Article, { editable: editableData, editMode: this.state.editMode });
            case 'upToDate':
                return _jsx(Editor_Reference_UpToDate, { editable: editableData, editMode: this.state.editMode });
            case 'book':
                return _jsx(Editor_Reference_Book, { editable: editableData, editMode: this.state.editMode });
            default:
                return _jsx(_Fragment, {});
        }
    };
}
//# sourceMappingURL=Editor_Reference.js.map